var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4658 23C22.6492 20.873 25.1271 14.9467 23.0001 9.76321C20.8731 4.57972 14.9468 2.10191 9.76335 4.22887C4.57986 6.35584 2.10205 12.2821 4.22901 17.4656C6.35597 22.6491 12.2823 25.1269 17.4658 23Z",
    fill: "url(#paint0_linear_6808_8863)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83343 28.9479L7.78047 27.1347C7.66475 27.034 7.52091 26.9712 7.36837 26.9549L4.82839 26.7451C4.78493 26.7418 4.74291 26.7281 4.70592 26.7051C4.66893 26.682 4.63807 26.6504 4.61598 26.6128C4.59388 26.5753 4.58122 26.5329 4.57907 26.4894C4.57691 26.4459 4.58533 26.4025 4.60361 26.3629L8.23002 18.1211L13.9019 20.6236L10.268 28.8655C10.249 28.9039 10.2213 28.9373 10.1872 28.9633C10.153 28.9892 10.1133 29.0068 10.0712 29.0148C10.0291 29.0228 9.98572 29.0209 9.94446 29.0093C9.9032 28.9977 9.8652 28.9767 9.83343 28.9479Z",
    fill: "url(#paint1_linear_6808_8863)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4009 28.9469L19.4539 27.1112C19.5696 27.0105 19.7135 26.9478 19.866 26.9314L22.406 26.7216C22.4494 26.7184 22.4914 26.7047 22.5284 26.6816C22.5654 26.6586 22.5963 26.627 22.6184 26.5894C22.6405 26.5518 22.6531 26.5095 22.6553 26.466C22.6575 26.4224 22.649 26.3791 22.6308 26.3395L19.0043 18.0977L13.3325 20.6002L16.9589 28.872C16.9783 28.9111 17.0068 28.9452 17.0419 28.9712C17.077 28.9973 17.1177 29.0147 17.1608 29.022C17.2039 29.0293 17.2482 29.0263 17.2899 29.0133C17.3316 29.0002 17.3697 28.9775 17.4009 28.9469Z",
    fill: "url(#paint2_linear_6808_8863)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.424 20.4232C24.184 16.6633 24.184 10.5672 20.424 6.80723C16.6641 3.04728 10.568 3.04728 6.808 6.80723C3.04805 10.5672 3.04805 16.6633 6.808 20.4232C10.568 24.1832 16.6641 24.1832 20.424 20.4232Z",
    fill: "url(#paint3_linear_6808_8863)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5803 18.5795C21.322 15.8378 21.322 11.3927 18.5803 8.65096C15.8386 5.90926 11.3934 5.90926 8.65172 8.65096C5.91002 11.3927 5.91002 15.8378 8.65172 18.5795C11.3934 21.3212 15.8386 21.3212 18.5803 18.5795Z",
    fill: "url(#paint4_linear_6808_8863)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94876 13.9613C6.94667 12.5944 7.34446 11.2569 8.09313 10.1133C8.8418 8.96976 9.90863 8.0702 11.1622 7.52544C12.4158 6.98069 13.8013 6.81454 15.1482 7.04747C16.495 7.28039 17.7443 7.90222 18.7421 8.83634C18.0968 8.16343 17.3236 7.6261 16.468 7.25584C15.6123 6.88558 14.6914 6.68983 13.7591 6.68007C12.8268 6.67031 11.902 6.84674 11.0388 7.19901C10.1756 7.55129 9.39137 8.07232 8.73212 8.73157C8.07287 9.39082 7.55184 10.175 7.19956 11.0382C6.84729 11.9015 6.67086 12.8263 6.68062 13.7586C6.69038 14.6908 6.88612 15.6118 7.25639 16.4674C7.62665 17.3231 8.16398 18.0962 8.83689 18.7415C7.62204 17.4465 6.94678 15.7369 6.94876 13.9613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6172 6.5957H13.4374C14.7395 6.62842 16.0034 7.0422 17.0728 7.78583C18.1422 8.52946 18.9701 9.57031 19.4541 10.7796C19.938 11.9889 20.0568 13.3135 19.7958 14.5896C19.5347 15.8657 18.9052 17.0373 17.9852 17.9593C17.0651 18.8814 15.895 19.5134 14.6195 19.7773C13.3439 20.0412 12.019 19.9253 10.8087 19.444C9.59835 18.9627 8.55568 18.137 7.8097 17.0693C7.06373 16.0015 6.64718 14.7385 6.61161 13.4364C6.6079 13.4963 6.6079 13.5564 6.61161 13.6163C6.61161 15.0048 7.02336 16.3621 7.79479 17.5167C8.56621 18.6712 9.66267 19.571 10.9455 20.1024C12.2283 20.6338 13.6399 20.7728 15.0018 20.5019C16.3637 20.231 17.6146 19.5624 18.5964 18.5805C19.5783 17.5987 20.2469 16.3477 20.5178 14.9859C20.7887 13.624 20.6497 12.2124 20.1183 10.9296C19.5869 9.64677 18.6871 8.55031 17.5326 7.77888C16.378 7.00745 15.0207 6.5957 13.6322 6.5957H13.6172Z",
    fill: "#AF3004"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2086 16.8976H12.9222V12.785H11.3279V11.8158C11.5514 11.8218 11.7658 11.8067 11.9711 11.7705C12.1825 11.7282 12.3697 11.6588 12.5327 11.5621C12.7018 11.4595 12.8437 11.3266 12.9585 11.1636C13.0732 11.0005 13.1487 10.7982 13.1849 10.5566H14.2086V16.8976Z",
    fill: "#AF3004"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6808_8863",
    x1: 3.46611,
    y1: 13.613,
    x2: 23.756,
    y2: 13.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ED9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F9DB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6808_8863",
    x1: 7.88536,
    y1: 26.303,
    x2: 9.57868,
    y2: 22.8339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6808_8863",
    x1: 19.1017,
    y1: 26.2496,
    x2: 17.5583,
    y2: 22.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6808_8863",
    x1: 3.98721,
    y1: 13.6144,
    x2: 23.2432,
    y2: 13.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F9DB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ED9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6808_8863",
    x1: 17.6911,
    y1: 17.6904,
    x2: 9.11213,
    y2: 9.11137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F9DB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ED9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/goldMedal.637c965111adb2e627e9d85ef6565d48.svg";
export { ForwardRef as ReactComponent };